import { BookingWidget } from "@/components/BookingWidget";
import { IMAGES } from "@/lib/constants";
import { TrainFront } from "lucide-react";

const STATIONS = ["London Paddington", "London King's Cross", "London Euston", "London Waterloo", "London Victoria", "Manchester Piccadilly", "Birmingham New Street", "Liverpool Lime Street", "Leeds", "Edinburgh Waverley", "Glasgow Central"];

export default function Station() {
  return (
    <div>
      <section className="relative bg-navy">
        <img src={IMAGES.station} alt="Station" className="absolute inset-0 h-full w-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-navy/70" />
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14 lg:py-20">
          <div className="grid items-center gap-10 lg:grid-cols-12">
            <div className="lg:col-span-5">
              <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-xs font-medium text-white"><TrainFront size={14} className="text-brand" /> Station Transfers</span>
              <h1 className="mt-4 font-heading text-4xl font-bold text-white lg:text-5xl">Station pickups & drop-offs</h1>
              <p className="mt-4 max-w-md text-slate-300">Reliable transfers to and from every major UK rail station. Add your train details and we'll be ready at the platform pickup point.</p>
            </div>
            <div className="lg:col-span-7"><BookingWidget initialTab="station" /></div>
          </div>
        </div>
      </section>
      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        <h2 className="font-heading text-2xl font-bold text-navy">Popular stations</h2>
        <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
          {STATIONS.map((s) => <div key={s} className="rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm font-medium text-navy">{s}</div>)}
        </div>
      </section>
    </div>
  );
}
